export default __webpack_public_path__ + "assets/7605a0.svg";